'use strict';

/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

var _freeGlobal = freeGlobal;

module.exports = _freeGlobal;
